var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('image-cropper-upload',{attrs:{"url":_vm.url},on:{"uploaded":_vm.handleUploaded}})}
var staticRenderFns = []

export { render, staticRenderFns }